import { useEffect } from 'react';
import { LiaExchangeAltSolid } from 'react-icons/lia';
import { useSearchParams } from 'next/navigation';
import { getNetworkLogo } from '@/lib/misc/tokenImageHelper';
import { toSpecialFixed } from '@/lib/misc/utils';
import ImageWithFallback from '@/components/shared/ImageWithFallback';
export default function Transaction({
  txItem,
  index,
  modalData,
  setModalData,
  setModalAnimation = null
}) {
  const tokensIn = txItem?.token_prices?.tokensIn;
  const tokensOut = txItem?.token_prices?.tokensOut;
  const tokensInUSDValue = tokensIn?.reduce((acc, token) => {
    const formattedAmount = token?.amountToUse * parseFloat(token.quote_rate?.toString());
    return acc + formattedAmount;
  }, 0);
  const error = txItem?.status === 'error' || txItem?.result?.decodedResponse?.status != 'success';
  const isFinalizing = !txItem?.settled_tokens_out || !txItem?.settled_tokens_out?.length;
  const _searchParams = useSearchParams();
  const _orderId = _searchParams.get('order_id');
  useEffect(() => {
    if (setModalAnimation !== null) {
      setTimeout(() => {
        setModalAnimation(modalData !== null);
      }, 100);
    }
  }, [modalData]);
  function toggleModal() {
    setModalData({
      isTransfer: false,
      txItem
    });
  }
  useEffect(() => {
    if (Number(_orderId) === txItem.id) {
      toggleModal();
    }
  }, [txItem, _orderId]);
  return <div data-sentry-component="Transaction" data-sentry-source-file="Transaction.tsx">
      <div key={index} onClick={() => {
      console.log('Transaction', {
        txItem
      });
      toggleModal();
    }} className='w-full h-[70px] flex items-center pl-4 pr-4 md:hover:bg-genius-blue cursor-pointer transition-colors'>
        <div className='flex w-full justify-between items-center'>
          <div className='flex gap-x-5 items-center relative pl-16'>
            <div className='absolute w-fit top-1 left-0 flex'>
              <div className='w-[35px] h-[35px] flex items-center bg-genius-blue rounded-[8px] justify-center'>
                <LiaExchangeAltSolid className='w-[18px] h-[18px] text-genius-cream' data-sentry-element="LiaExchangeAltSolid" data-sentry-source-file="Transaction.tsx" />
              </div>
              <ImageWithFallback src={getNetworkLogo(tokensIn?.[0]?.network)} width={14} height={14} alt='network-logo' className='absolute bottom-[-5px] right-0' data-sentry-element="ImageWithFallback" data-sentry-source-file="Transaction.tsx" />
              <ImageWithFallback src={getNetworkLogo(tokensOut?.[0]?.network)} width={14} height={14} alt='network-logo' className='absolute bottom-[-5px] left-8' data-sentry-element="ImageWithFallback" data-sentry-source-file="Transaction.tsx" />
            </div>
            <div className='flex flex-col gap-y-0'>
              <div className={`flex items-center text-[16px] ${txItem?.order_type?.includes('Buy') ? 'text-green-300' : txItem?.order_type?.includes('Sell') ? 'text-red-300' : 'text-genius-cream'} capitalize`}>
                {txItem?.order_type?.replace('_', ' ').replace('MARKET', '')?.toLowerCase()}
                <div className={`ml-2
                    px-2 rounded-lg
                    text-[12px]
                                 ${error ? 'text-red-400 bg-[#F871714D] ' : isFinalizing ? 'text-yellow-500 bg-[#F8DD714D]' : 'text-green-400 bg-emerald-900'}`}>
                  {error ? 'Failed' : isFinalizing ? 'Finalizing...' : 'Success'}
                </div>
              </div>
              <div className='flex items-center text-[10px] flex-wrap'>
                {tokensIn?.map((token, idx) => <p className='text-genius-cream/50  mr-1' key={idx}>
                    {token.contract_ticker_symbol}
                    {idx < tokensIn.length - 1 ? ', ' : ''}
                  </p>)}
                {tokensOut?.map((token, idx) => <p className='text-genius-cream/50  mr-1' key={idx}>
                    - {token.contract_ticker_symbol}
                    {idx < tokensIn.length - 1 ? ', ' : ''}
                  </p>)}
                {tokensOut?.map((_, idx) => <p className='text-genius-cream/50 whitespace-nowrap' key={idx}>
                    {' - '}
                    {new Date(txItem.created_at).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric'
                })}
                  </p>)}
              </div>
            </div>
          </div>
          <div className='flex flex-col gap-y-2'>
            <div className='text-right text-genius-cream text-[16px]'>
              {error ? 'Error' : <>
                  {`$${toSpecialFixed(tokensInUSDValue, 3).value?.toString().length > 15 ? tokensInUSDValue?.toFixed(3) : toSpecialFixed(tokensInUSDValue, 3).value}`}
                  <p className='text-[10px] text-genius-cream/50'>
                    {toSpecialFixed(tokensIn?.[0]?.amountToUse).value}{' '}
                    {tokensIn?.[0]?.contract_ticker_symbol}
                  </p>
                </>}
            </div>
          </div>
        </div>
      </div>
    </div>;
}